<div class="bloco">
    <h5 class="titulo">Sócio Antifraude</h5>
    <div *ngIf="naoEncontrouRegistros">
        <div class="row">
            <div class="col-auto item">Nenhum registro encontrado <i class="far fa-frown"></i></div>
        </div>
    </div>
    <div *ngIf="naoSolicitou">
        <div class="row">
            <div class="col-auto item">Você não solicitou essa consulta.</div>
            <!-- <div class="col-auto item"><button (click)="consultar()" [disabled]="consultando" class="btn btn-primary"><i class="fas fa-search"></i> Você não solicitou essa consulta. {{txtButtonConsultar}}</button></div> -->
        </div>
    </div>
    <div *ngIf="dados.antifraude_socio">
        <div class="row">
          <table class="table table-sm ">
            <thead>
              <tr>
                <th>CNPJ</th>
                <th>Tipo Documento</th>
                <th>Documento</th>
                <th>Nome</th>
                <th>Faixa de Idade</th>
                <th>Situação</th>
                <th>Possível Óbito</th>
                <th>CCF</th>
                <th>PPE(Pessoa Politicamente Exposta)</th>
                <th>Servidor Público Federal</th>
                <th>Cargo</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of dados.antifraude_socio">
                <td>{{row.cnpj | mascara: 'cnpj'}}</td>
                <td>{{row.tipo_documento}}</td>
                <td>{{row.documento | mascara: 'cpf'}}</td>
                <td>{{row.nome_rf}}</td>
                <td>{{row.faixa_idade}}</td>
                <td>{{row.situacao_rf}}</td>
                <td>{{row.possivel_obito}}</td>
                <td>{{row.indicacao_ccf}}</td>
                <td>{{row.indicacao_ppe}}</td>
                <td>{{row.indicacao_sv_federal}}</td>
                <td>{{row.cargo}}</td>
              </tr>
            </tbody>
          </table>
        </div>
    </div>
</div>